
import "@/assets/css/pay-by-app-btn.css"
import {computed, defineComponent} from 'vue'
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";
import {bankPayFlowsIn} from "@/service/bankPayFlows";

export default defineComponent({
  props: ['flowData'],
  emits: ['btn:click'],
  setup(props) {
    const appPayLogos = computed<string[]>(() => {
      return bankPayFlowsIn(props.flowData).map((item) => item.method)
    })

    return {
      paymentMethodsHelper,
      appPayLogos,
    }
  }
})
